<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>

  <div
    class="
      h-screen
      flex
      w-full
      bg-img
      vx-row
      no-gutter
      items-center
      justify-center
    "
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center" style="">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                v-bind:src="loginpng"
                style="max-height: 180px"
                alt="login"
                class="mx-auto"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Giriş</h4>
                  <p>Lütfen kullanıcı adınızı giriniz.</p>
                </div>
                <div class="vx-row" style="align-items: flex-end">
                  <div class="vx-col sm:w-full md:w-full lg:w-7/12">
                    <vs-input
                      name="email"
                      type="email"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      label-placeholder="Kullanıcı Adı"
                      v-model="email"
                      @input="handler"
                      class="w-full"
                    >
                    </vs-input>
                  </div>
                  <div
                    class="vx-col sm:w-full md:w-full lg:w-4/12"
                    v-if="mailSendValidate"
                  >
                    <b-button variant="primary" @click="onSubmit" size="lg">
                      Gönder
                    </b-button>
                  </div>
                </div>
                <div class="vx-row" v-if="mailTimerValidate">
                  <div
                    class="vx-col sm:w-full md:w-full lg:w-12/12"
                    style="text-align: center"
                  >
                    <p style="margin-top: 1rem">
                      Mail adresinize gelen kodu giriniz
                    </p>
                  </div>

                  <div
                    class="vx-col sm:w-full md:w-full lg:w-12/12"
                    style="margin-bottom: 25px; text-align: center"
                  >
                    <h6>Kod girmek için {{ countDown }} saniyeniz kaldı</h6>
                  </div>
                  <br />
                  <div class="vx-col sm:w-full md:w-full lg:w-7/12">
                    <vs-input
                      primary
                      border
                      shadow
                      maxlength="6"
                      name="code"
                      type="code"
                      class="w-full"
                      v-model="code"
                      placeholder="Kodu giriniz"
                      @keyup.enter="loginBtn()"
                      v-on:keypress="isNumber($event)"
                    >
                    </vs-input>
                  </div>
                  <div class="vx-col sm:w-full md:w-full lg:w-4/12">
                    <b-button variant="primary" @click="loginBtn" size="lg">
                      Giriş
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <MailCodeComponent ref="mailCode" />
  </div>
</template>

<script>
import Store from "../../store/store";
import state from "../../store/state";
import MailCodeComponent from "../components/crm-components/MailCodeComponent.vue";
import router from "../../router";
import userJson from "../../../public/user.json";

export default {
  components: { MailCodeComponent },
  data() {
    return {
      loginpng: "",
      value3: "",
      mailSendValidate: true,
      mailTimerValidate: false,
      countDown: 120,
      email: "",
      code: "",
      password: "",
      bayikodu: "",
      checkbox_remember_me: false,
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    };
  },
  created() {
    this.loginpng = userJson.userLogo;
  },
  methods: {
    handler() {
      this.mailTimerValidate = false;
    },
    loginBtn() {
      var vs = this.$vs;

      if (this.code == Store.state.strMailCode) {
        this.countDown = 0;
        vs.notify({
          iconPack: "feather",
          color: "success",
          icon: "icon-alert-circle",
          title: "Giriş Başarılı",
          text: "Lütfen Bekleyin Yönlendirileceksiniz.",
        });
        router.push('/home');
      } else {
        vs.notify({
          iconPack: "feather",
          color: "danger",
          icon: "icon-alert-circle",
          title: "Hatalı",
          text: `Girilen kod uyuşmuyor`,
        });
      }
    },
    isNumber(val) {
      val = val ? val : window.event;
      var charCode = val.which ? val.which : val.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        val.preventDefault();
      } else {
        return true;
      }
    },

    mailGonder() {
      var vs = this.$vs;
      if (this.email == null || this.email == "") {
        vs.notify({
          iconPack: "feather",
          color: "danger",
          icon: "icon-alert-circle",
          title: "Hatalı",
          text: `Mail boş girilemez`,
        });
      } else {
        this.mailSendValidate = true;
        const payload = {
          vs: this.$vs,
          mailControlCode: this.code,
          userDetails: {
            email: this.email,
          },
        };
        this.$store.dispatch("login", payload);
      }
    },
    countDownTimer() {
      var vs = this.$vs;
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      } else if (this.countDown == 0) {
        //  this.mailGonder();
        this.$refs.mailCode.createMailCode();

        vs.notify({
          iconPack: "feather",
          color: "danger",
          icon: "icon-alert-circle",
          title: "Süre doldu",
          fixed: true,
          text: "Tekrar kod almak için Gönder'e tıklayınız",
        });
      }
    },
    onSubmit() {
      var vs = this.$vs;

      if (this.email == null || this.email == "") {
        vs.notify({
          iconPack: "feather",
          color: "danger",
          icon: "icon-alert-circle",
          title: "Hatalı",
          text: `Mail boş girilemez`,
        });
      } else {
        this.mailSendValidate = true;
        const payload = {
          vs: this.$vs,
          mailControlCode: this.code,
          userDetails: {
            email: this.email,
          },
        };
        this.$store.dispatch("login", payload).then(
          (response) => {
            if (response[0].EMAIL != "") {
              //    alert("in");
              this.countDown = 0;

              this.mailTimerValidate = true;
              var vs = this.$vs;

              console.log(this.$refs.mailCode.$el.innerHTML);

              this.countDown = 120;
              this.countDownTimer();

              const soap = require("soap");
              const url = state.sistemAddress;
              const args = {
                ALICI: response[0].EMAIL,
                MESAJ: this.$refs.mailCode.$el.innerHTML,
                KONU: "Mail kontrol kodu",
              };
              console.log(response[0].EMAIL)


              soap.createClient(url, function (err, client) {
                client.mailGonder(args, function (err, result) {
                  // console.log(result);
                  var vm = this;
                  if (result == "-1" || result == "") {
                    vs.notify({
                      title: "Hatalı Giriş",
                      text: "Mail adresi yanlış olabilir",
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "danger",
                    });
                  } else {
                    vs.notify({
                      title: "Mail gönderildi",
                      text: "giriş",
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "success",
                    });
                  }
                });
              });
            } else {
              //   alert("in");
              vs.notify({
                title: "Hatalı Giriş",
                text: "Mail adresi yanlış olabilir",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
              });
            }
          },
          (error) => {
            console.error(
              "Got nothing from server. Prompt user to check internet connection and try again"
            );
          }
        );
      }
    },
  },
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
